<template>
<span>
	<span v-if="typeof(shoptype) === 'number' || !shoptype" :class="['shoptype','type'+shoptype]">
		{{ shoptype === 1 ?'授权':shoptype === 2 ? '灰':shoptype === 3 ? '黑' : '非授权'}}
	</span>
	<span v-else
		:class="['shoptype','type'+ (shoptype === '授权店铺'?1:shoptype === '灰名单' ? 2: shoptype === '黑名单' ? 3:4)]"
	>{{ shoptype === '授权店铺'?'授权':shoptype === '灰名单' ? '灰':shoptype === '黑名单' ? '黑' :''}}</span>

</span>
</template>
<script>
export default {
	name:'shopType',
	props:["shoptype"],
}
</script>
<style lang="scss" scoped>
.shoptype {
  display: inline-flex;
	align-items: center;
	font-size: 14px;
	color: #fff;
	border-radius: 3px;
	padding: 0px 3px;
	height: 20px;
	line-height: 20px;
	margin: 0 0 0 5px;
	vertical-align: super;
	 background: #d4d4d4;
	&.type{
		background: #d4d4d4;
	}
  &.type1 {
    background: #52c41a;
  }
  &.type2 {
    background: #d4d4d4;
  }
  &.type3 {
    background: #333333;
  }
  &.type4{
	background: none;
  }
}
</style>